var render = function render(){var _vm=this,_c=_vm._self._c;return _c('container',[_c('row',[_c('column',{staticClass:"w-full"},_vm._l((_vm.codes),function(code,i){return _c('confirmation-card',_vm._b({key:i,attrs:{"phone":_vm.phone}},'confirmation-card',code,false))}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }